import dayjs from 'dayjs'
var sb = require('@sb/util')
import store from '@sb/store'

export default {
	name: 'MessageInput',
	props: ['disabled', 'convoKey'],

	data () {
		return {
			...store.bind(this, ['convoEventM']),
			message: '',
			openEmoji: false, // true if emoji window is opened
		}
	},

	mounted () {
		store.onConvoEvent(this, ev => {
			var evconvokey = sb.convoKeyOfEv(ev)
			if (evconvokey !== this.convoKey) return
			this.$forceUpdate()
		})
	},

	render () {
		var buttons = (
			<div class="d-flex flex-row align-self-end">
				{this.renderEmoji()}
				<div
					data-tooltip-position="top-left"
					class="message-input--button message-input--attachment-button"
					vOn:click_stop={this.selectFile}></div>
			</div>
		)
		var msg = sb.trim(this.message)
		if (msg.length > 0) {
			buttons = (
				<div class="d-flex flex-row align-self-end">
					{this.renderEmoji()}
					<div
						data-tooltip-position="top-left"
						class="message-input--button message-input--send-button"
						vOn:click={() => this.submitMessage()}></div>
				</div>
			)
		}

		var containercls = ''
		var disabled = this.hasUnfinishRequiredForm() || this.disabled
		if (disabled) containercls = 'message-input--disabled'

		return (
			<div
				class={`message-input ${containercls}`}
				vOn:click={() => {
					this.$refs.messageInput.focus()
				}}>
				<input class="d-none" ref="fileInput" type="file" vOn:change={this.sendFile} multiple />
				<textarea
					disabled={disabled}
					class="message-input--input"
					maxlength="1024"
					placeholder={this.$t('message_input_help')}
					ref="messageInput"
					rows="1"
					vOn:paste={this.pasteImage}
					data-emojiable="true"
					vModel={this.message}
					vOn:keydown={this.onKeydown}
					vOn:keyup={this.onKeyup}
				/>
				{buttons}
			</div>
		)
	},

	methods: {
		hasUnfinishRequiredForm () {
			var events = sb.orderBy(
				sb.map(this.convoEventM[this.convoKey], e => e),
				'created',
				'desc',
			)
			// find first msg_sent event of agent
			var last_agent_sent
			for (let ev of events) {
				if (sb.get(ev, 'type') !== 'message_sent') continue
				if (sb.get(ev, 'by.type') === 'user') continue
				last_agent_sent = ev
				break
			}

			if (sb.get(last_agent_sent, 'by.type') === 'user') last_agent_sent = null

			let attachments = sb.get(last_agent_sent, 'data.message.attachments', [])
			let pendingForms = sb.filter(attachments, att => {
				if (!att) return false
				if (att.type !== 'form' && att.type !== 'ask_info_form') return false
				var form = att.form
				if (!form) return false
				var state = sb.parseJSON(form.state) || {}
				if (!state.require_finished && att.type !== 'ask_info_form') return false
				if (form._submitted) return false
				return true
			})

			return sb.size(pendingForms) > 0
		},

		renderEmojiPopup () {
			if (!this.openEmoji) return null
			return (
				<div class="emoji-picker" v-clickaway={this.hideEmoji}>
					<div class="emoji-picker-background-item">
						<div
							vOn:click={() => this.emojiPick(':like:')}
							data-tooltip=":like:"
							class="emoji-picker--item emoji--like"
						/>
					</div>
					<div class="emoji-picker-background-item">
						<div
							vOn:click={() => this.emojiPick(':unlike:')}
							data-tooltip=":unlike:"
							class="emoji-picker--item emoji--unlike"
						/>
					</div>
					<div class="emoji-picker-background-item">
						<div
							vOn:click={() => this.emojiPick(':angry:')}
							data-tooltip=":angry:"
							class="emoji-picker--item emoji--angry"
						/>
					</div>
					<div class="emoji-picker-background-item">
						<div
							vOn:click={() => this.emojiPick(':confused:')}
							data-tooltip=":confused:"
							class="emoji-picker--item emoji--confused"
						/>
					</div>
					<div class="emoji-picker-background-item">
						<div
							vOn:click={() => this.emojiPick(':crying:')}
							data-tooltip=":crying:"
							class="emoji-picker--item emoji--crying"
						/>
					</div>
					<div class="emoji-picker-background-item">
						<div
							vOn:click={() => this.emojiPick(':grinning:')}
							data-tooltip=":grinning:"
							class="emoji-picker--item emoji--grinning"
						/>
					</div>
					<div class="emoji-picker-background-item">
						<div
							vOn:click={() => this.emojiPick(':heart-eyes:')}
							data-tooltip=":heart-eyes:"
							class="emoji-picker--item emoji--heart-eyes"
						/>
					</div>
					<div class="emoji-picker-background-item">
						<div
							vOn:click={() => this.emojiPick(':neutral:')}
							data-tooltip=":neutral:"
							class="emoji-picker--item emoji--neutral"
						/>
					</div>
					<div class="emoji-picker-background-item">
						<div vOn:click={() => this.emojiPick(':sad:')} data-tooltip=":sad:" class="emoji-picker--item emoji--sad" />
					</div>
					<div class="emoji-picker-background-item">
						<div
							vOn:click={() => this.emojiPick(':sleepy:')}
							data-tooltip=":sleepy:"
							class="emoji-picker--item emoji--sleepy"
						/>
					</div>
					<div class="emoji-picker-background-item">
						<div
							vOn:click={() => this.emojiPick(':smiling:')}
							data-tooltip=":smiling:"
							class="emoji-picker--item emoji--smiling"
						/>
					</div>
					<div class="emoji-picker-background-item">
						<div
							vOn:click={() => this.emojiPick(':surprised:')}
							data-tooltip=":surprised:"
							class="emoji-picker--item emoji--surprised"
						/>
					</div>
					<div class="emoji-picker-background-item">
						<div
							vOn:click={() => this.emojiPick(':tired:')}
							data-tooltip=":tired:"
							class="emoji-picker--item emoji--tired"
						/>
					</div>
					<div class="emoji-picker-background-item">
						<div
							vOn:click={() => this.emojiPick(':tongue-out:')}
							data-tooltip=":tongue-out:"
							class="emoji-picker--item emoji--tongue-out"
						/>
					</div>
					<div class="emoji-picker-background-item">
						<div
							vOn:click={() => this.emojiPick(':wink:')}
							data-tooltip=":wink:"
							class="emoji-picker--item emoji--wink"
						/>
					</div>
				</div>
			)
		},

		resizeInput: sb.throttle(function () {
			// TODO: ctrl+A then press backspace dont reset size rightaway
			const input = this.$refs.messageInput
			input.style.setProperty('height', '1em', 'important')
			const height = Math.min(200, input.scrollHeight)
			input.style.setProperty('height', `${height}px`, 'important')
		}, 5),

		focus () {
			if (this.disabled) return
			this.$refs.messageInput && this.$refs.messageInput.focus()
		},

		renderEmoji () {
			return (
				<div>
					{this.renderEmojiPopup()}
					<div class="message-input--button message-input--emoji-button" vOn:click_stop={this.toggleEmoji}></div>
				</div>
			)
		},
		toggleEmoji () {
			this.focus()
			if (this.disabled) return
			this.openEmoji = !this.openEmoji
		},
		hideEmoji () {
			this.openEmoji = false
		},

		emojiPick (code) {
			const input = this.$refs.messageInput
			const position = input.selectionStart
			const message = this.message
			this.message = [message.slice(0, position), code, message.slice(position)].join('')
			this.hideEmoji()
			input.focus()
		},

		onEnter: sb.throttle(function () {
			this.submitMessage()
		}, 50),

		onKeyup (e) {
			this.message = e.target.value

			if (e.keyCode === 13 && e.shiftKey === false) {
				this.onEnter()
			}
			this.sendTyping()
		},

		onKeydown (e) {
			this.message = e.target.value
			this.resizeInput()
			if (e.keyCode === 13 && e.shiftKey === false) {
				e.preventDefault()
			}
		},

		selectFile () {
			if (this.disabled) return
			this.$refs.fileInput.click()
		},

		sendFile () {
			const files = this.$refs.fileInput.files
			sb.log('files:', files)

			this._sendFile(files)
		},

		async _sendFile (files) {
			if (sb.size(files) === 0) return
			if (this.disabled) return
			const result = await store.uploadToS3(files)

			this.$refs.fileInput.value = ''
			sb.log('upload result:', result)

			const attachments = []
			for (let file of result) {
				const attachment = {
					type: 'file',
					mimetype: file.type,
					url: sb.replaceFileUrl(file.url),
					name: file.name,
					size: file.size,
				}

				attachments.push(attachment)
			}
			this.$emit('send', { attachments })
			// reset file input to re-select the same file
			this.$refs.fileInput.value = ''
		},

		async submitMessage (msg) {
			msg = msg || sb.trim(this.message) || ''
			if (!msg) return
			if (this.disabled) return
			this.message = ''
			this.openEmoji = false

			this.$emit('send', { text: msg, format: 'plaintext' })
		},

		sendTyping () {
			if (!this.convoKey) return
			return store.typing(this.convoKey)
		},

		pasteImage (event) {
			sb.log('event', event)

			if (!window.File || !window.FileReader || !window.FileList || !window.Blob) {
				sb.log('The File APIs are not fully supported in this browser.')
				return
			}

			// if (sb.size(event.clipboardData.items)) {
			// 	sb.log('not support')
			// 	return
			// }

			const name = `Paste-image-${dayjs(new Date()).format('YYYY-MM-DD-HH-mm-ss')}`
			let blob = null
			const copiedData = event.clipboardData.items[0]
			if (copiedData.type.indexOf('image') === 0) {
				blob = copiedData.getAsFile()
			}

			if (!blob) {
				sb.log('paste image: no data')
				return
			}

			const parts = [blob, new ArrayBuffer()]
			const file = new File(parts, `${name}.png`, { type: 'image/png' })

			this._sendFile([file])
		},
	},
}
